/** A ficha do card, carregada sob demanda.
 *
 * Um módulo só para isto porque **duas telas a abrem** — o funil e a agenda —,
 * e um `lazy` em cada uma não adianta nada: basta uma delas importar de forma
 * estática para o Rollup manter o módulo no bundle de entrada, e o aviso que
 * ele dá nesse caso é fácil de ler como ruído.
 *
 * Ela é a maior folha do produto: timeline, documentos, comentários, seletor
 * de etiquetas. Estática, entrava no primeiro carregamento de todo mundo —
 * inclusive de quem abre o funil, olha e fecha. Foi o que devolveu a folga do
 * orçamento quando o seletor de etiquetas entrou (ver `.size-limit.md`).
 */

import { lazy } from "react";

export const PainelDaOportunidade = lazy(async () => ({
  default: (await import("./PainelDaOportunidade")).PainelDaOportunidade,
}));
